import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../lib/api';

/** Hardcoded demo pair — used when backend is unreachable or landing ids are unset. */
export const FALLBACK_PROJECT_ID = 'a3196be7-b04d-4f25-a249-641a0fce80cf';
export const FALLBACK_ANALYSIS_ID = '9f95278c-5f3d-41dc-a2ac-fa6b4c0b6303';

const FALLBACK_PATH = `/analysis/${FALLBACK_PROJECT_ID}?analysisId=${FALLBACK_ANALYSIS_ID}`;

/**
 * Landing route: asks GET /api/ for landing_project_id + landing_analysis_id,
 * then Navigate. On null/error/timeout, falls back to the hardcoded demo pair.
 */
export default function LandingRedirect() {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);

    axios
      .get(`${API_BASE}/`, { timeout: 4000, signal: controller.signal })
      .then((res) => {
        if (cancelled) return;
        const projectId = res?.data?.landing_project_id;
        const analysisId = res?.data?.landing_analysis_id;
        const chartView = res?.data?.landing_chart_view;
        if (projectId && analysisId) {
          const params = new URLSearchParams({ analysisId });
          if (chartView) params.set('chartView', chartView);
          setTarget(`/analysis/${projectId}?${params.toString()}`);
        } else {
          setTarget(FALLBACK_PATH);
        }
      })
      .catch(() => {
        if (!cancelled) setTarget(FALLBACK_PATH);
      })
      .finally(() => {
        clearTimeout(timer);
      });

    return () => {
      cancelled = true;
      clearTimeout(timer);
      controller.abort();
    };
  }, []);

  if (!target) {
    return (
      <div style={{ padding: '2rem', color: '#a1a1aa' }}>
        Loading Wave Studio...
      </div>
    );
  }

  return <Navigate to={target} replace />;
}
